import { render } from "./BookingsTable.vue?vue&type=template&id=74f81806"
import script from "./BookingsTable.vue?vue&type=script&lang=js"
export * from "./BookingsTable.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__